module.exports = __webpack_public_path__ + "static/media/profile-pic.89854341.jpg";